import React from "react";
import { theme, Modal, Row, Form, Col, Input, Spin, Select, InputNumber, } from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import ErrorMessages from "../../common/ErrorMessages";
import useDropdownItem from "../../common/useDropdownItem";
import { URL_PRODUCT, URL_SALE, URL_SKIM } from "../../constants/urls";
import { PRODUCT_TYPE, SKIM_STATUS } from "../../constants/string";
import _ from "lodash";

export default function ProduceLotSkimModal(props) {
  const { target, open, onClose, onUpdate } = props;
  const [form] = Form.useForm();
  const isCreate = target === 'add' ? true : false ;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages] = React.useState(null);
  const { token: { colorWarning, colorSuccess, colorError }, } = theme.useToken();
  const orderRef = Form.useWatch('order_ref', form);
  const [debouncedProduct, setDebouncedProduct] = React.useState('')
  const productDropdown = useDropdownItem({
    manual: true, 
    url: URL_PRODUCT.PRODUCT , 
    label_renderer : (e) => e.short_name ? `${e.name} - ${e.short_name}` : `${e.name}`, 
    value:'id', 
    pagination: true, 
    params: { page_size: 50, name : debouncedProduct, type : PRODUCT_TYPE.SKIM},
  });
  const debounceProduct = React.useCallback(_.debounce((_searchVal) => { setDebouncedProduct(_searchVal) }, 800), []);

  const [debouncedOrderRef, setDebouncedOrderRef] = React.useState('');
  const produceOrderDropdown = useDropdownItem({
    manual : true,
    url: URL_SALE.SKIM_PRODUCE_ORDER,
    pagination: true,
    params: { page_size: 999, type: PRODUCT_TYPE.SKIM, lot_no : debouncedOrderRef , is_produced : false},
    label_renderer : (option) => `Lot No.: ${option.lot_no} ชนิดสินค้า: ${option.product_name}`,
  });

  const debounceOrderRef = React.useCallback(_.debounce((_searchVal) => { setDebouncedOrderRef(_searchVal) }, 800), []);

  const [debouncedSkimPondDropdown, setDebouncedSkimPondDropdown] = React.useState('');
  const skimPondLotDropdown = useDropdownItem({
    manual : true,
    url: URL_SKIM.SKIM_TRANSACTION,
    pagination: true,
    params: { page_size: 999, lot_no : debouncedSkimPondDropdown},
    label_renderer : (option) => `Lot No  : ${option.lot_no}`,
  });

  const debounceSkimPondDropdown = React.useCallback(_.debounce((_searchVal) => { setDebouncedSkimPondDropdown(_searchVal) }, 800), []);

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data['order_ref'] = orderRef ? orderRef : null
      if (target?.id) {
        await PATCH(`${URL_SKIM.SKIM_PRODUCE_TRANSACTION}${target.id}/`, data);
      } else {
        await POST(URL_SKIM.SKIM_PRODUCE_TRANSACTION, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if(open){
      skimPondLotDropdown.fetchOptions();
    }
  },[debouncedSkimPondDropdown])

  React.useEffect(() => {
    if(open){
      produceOrderDropdown.fetchOptions();
    }
  },[debouncedOrderRef])

  React.useEffect(() => {
    if(open){
      productDropdown.fetchOptions();
    }
  },[debouncedProduct])

  React.useEffect(() => {
    if(open){ 
      skimPondLotDropdown.fetchOptions();
      produceOrderDropdown.fetchOptions();
      productDropdown.fetchOptions();
      if(!isCreate) {
        setErrorMessages(null);
        form.setFieldsValue(target);
      }
    } else {
      form.resetFields();
    }
  },[open])

  return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={!isCreate ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={!isCreate ? "แก้ไขล็อตการผลิต" : "เพิ่มล็อตการผลิต"}
      width={450}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: !isCreate ? colorWarning : colorSuccess }, 
        loading
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item
              label="เลขล็อตการผลิต"
              name="lot_no"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="Lot No." />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={"skim_transactions"}
              label={"ล็อตบ่อยางสกิม"}
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder={"ล็อตบ่อยางสกิม"}
                options={!isCreate && target ? 
                  _.filter(skimPondLotDropdown.options,item => target.skim_transactions.includes(item.id) || item.status === SKIM_STATUS.CLOSED) :
                  _.filter(skimPondLotDropdown.options,item => item.status === SKIM_STATUS.CLOSED)
                }
                filterOption={false}
                notFoundContent={skimPondLotDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceSkimPondDropdown}
              /> 
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={"order_ref"}
              label={"ใบแจ้งผลิต Lot no."}
            >
              <Select
                showSearch
                allowClear
                disabled={target?.deliveried}
                placeholder={"ใบแจ้งผลิต"}
                options={target && orderRef ? 
                  _.filter([...produceOrderDropdown.options, 
                    { value : target.order_ref, 
                      label : `Lot No: ${target.produce_lot_no} ชนิดสินค้า: ${target.product_name}`,
                      product : target.product,
                      require_weight : target.weight,
                      require_amount : target.amount
                    }
                ], o => o.value !== null) : 
                  produceOrderDropdown.options}
                  filterOption={false}
                  notFoundContent={produceOrderDropdown.loading ? <Spin size="small" /> : "-"}
                  onSearch={debounceOrderRef}
                  onSelect={(value, option) => {
                    form.setFieldValue('product', option.product)
                    form.setFieldValue('weight', option.require_weight)
                    form.setFieldValue('amount', option.require_amount)
                  }}
              /> 
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="สินค้า"
              name="product"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Select 
                allowClear
                initialvalues={"-"}
                autoComplete="off" 
                placeholder="สินค้าสกิม"
                showSearch
                filterOption={false}
                notFoundContent={productDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceProduct}
                options={productDropdown.options}
                disabled={orderRef ? true : false}
                /> 
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="น้ำหนัก"
              name="weight"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <InputNumber placeholder="น้ำหนัก" style={{ width : '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="จำนวนก้อน"
              name="amount"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <InputNumber placeholder="จำนวนก้อน" style={{ width : '100%'}} />
            </Form.Item>
          </Col>
        </Row>
      </Form>

    </Modal>
  )
}